<template>
  <div class="card border-0 shadow-none rounded-1 mb-30">
    <div class="card-body p-xl-40">
      <h6 class="fs-18 mb-40 text-title">{{ $t("transfer_page.selected_products_for_transfer") }}</h6>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0 ls-1">{{ $t("transfer_page.product") }}</th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">{{ $t("transfer_page.product_code") }}</th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">{{ $t("transfer_page.available_stock") }}</th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">{{ $t("transfer_page.unit_cost") }}</th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">{{ $t("transfer_page.quantity") }}</th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">{{ $t("transfer_page.subtotal") }}</th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0">{{ $t("transfer_page.delete") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="item.product_id">
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0">{{ item.product_name }}</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">{{ item.product_code }}</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge fw-semibold fs-14" :class="item.available_stock > 0 ? 'badge-success-soft' : 'badge-danger-soft'">
                  {{ item.available_stock }}
                </span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">${{ Number(item.unit_cost || 0).toFixed(2) }}</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <div class="quantity-cell">
                  <QuantityCounter
                    :modelValue="item.qty"
                    @update:modelValue="$emit('update-qty', index, $event)"
                  />
                  <small v-if="item.qty > item.available_stock" class="d-block text-danger mt-2">
                    {{ $t("transfer_page.quantity_exceeds_available_stock") }}
                  </small>
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">${{ Number(item.subtotal || 0).toFixed(2) }}</td>
              <td class="shadow-none lh-1 text-end pe-0">
                <button class="delete-btn bg-transparent border-0" @click="$emit('remove-item', index)">
                  <img src="../../../assets/img/icons/close.svg" :alt="$t('transfer_page.delete')" />
                </button>
              </td>
            </tr>
            <tr v-if="items.length === 0">
              <td colspan="7" class="text-center py-4 text-muted">{{ $t("transfer_page.no_products_selected") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import QuantityCounter from "../../Purchases/CreatePurchase/QuantityCounter.vue";

interface TransferSelectedItem {
  product_id: number;
  product_name?: string;
  product_code?: string;
  unit_cost?: number;
  qty: number;
  subtotal?: number;
  available_stock: number;
}

export default defineComponent({
  name: "TransferSelectedProducts",
  components: {
    QuantityCounter,
  },
  props: {
    items: {
      type: Array as PropType<TransferSelectedItem[]>,
      default: () => [],
    },
  },
  emits: ["remove-item", "update-qty"],
});
</script>

<style scoped>
.quantity-cell {
  min-width: 150px;
}

.badge-success-soft {
  background: #e8f7ee;
  color: #1f9254;
}

.badge-danger-soft {
  background: #fdecec;
  color: #d33c43;
}
</style>
